import { JoyEnvironment } from './environment.interface';

export type { JoyEnvironment };

export const environment: JoyEnvironment = {
  isProduction: false,
  chainId: 80002,
  rpcUrl: 'https://rpc-amoy.polygon.technology/',
  paddleFiApiUrl: 'https://test-api.paddlefi.com',
  walletConnectProjectId: '95897051ca1c6b1712af7ea3b877665a',
  contracts: {
    approveTrade: '0xeD0e5Dab8f4283e4b09e1E3b2F499E80e6781B22',
    otcTrade: '0x7D75d2f7E33290c1012BFc604086bdE7800A4643',
    joyToken: '0xb1AE418E69750652Ed9e03375F73f5B433d01BCa',
    loan: '0xadF4c1BC36365403e7E0f1d2a657CFb11E3b1bb1',
  },
  bscScanUrl: 'https://amoy.polygonscan.com',
  platformAddress: '0x7D75d2f7E33290c1012BFc604086bdE7800A4643',
  referralBaseUrl: 'https://joy.defi/r/',
};
